/* Native court-sport runtime: section-scoped, editor reload-safe. */
(function(){
  'use strict';
  var instances=new Map();
  function initialize(host){
    if(instances.has(host)) instances.get(host)();
    var controller=new AbortController(), observers=[], frames=new Set(), timers=new Set(), intervals=new Set();
    function getId(id){return host.querySelector('[id="'+id+'"]');}
    function config(section,key,fallback){var element=host.querySelector('[data-court-section="'+section+'"][data-court-setting="'+key+'"]');return element?element.dataset.value:fallback;}
    function listen(target,event,callback,options){if(target)target.addEventListener(event,callback,Object.assign({},typeof options==='object'?options:{capture:!!options},{signal:controller.signal}));}
    function observe(callback,options){var observer=new IntersectionObserver(callback,options);observers.push(observer);return observer;}
    function courtFrame(callback){var id=requestAnimationFrame(function(time){frames.delete(id);callback(time);});frames.add(id);return id;}
    function courtLater(callback,delay){var id=setTimeout(function(){timers.delete(id);callback();},delay);timers.add(id);return id;}
    function courtInterval(callback,delay){var id=setInterval(callback,delay);intervals.add(id);return id;}
    instances.set(host,function(){controller.abort();observers.forEach(function(o){o.disconnect();});frames.forEach(cancelAnimationFrame);timers.forEach(clearTimeout);intervals.forEach(clearInterval);instances.delete(host);});
    /* Approved Pickleball 10:2/ketoneaid-sport-pickleball-v7.html; native interactions. */

(function(){
  var URL=config('top', 'share_url', 'https://ketoneaid.com/pages/ketones-for-pickleball'), TXT=config('top', 'share_text', 'This made me think of you: VKE for pickleball.');
  function copy(el){
    var done=function(){var o=el.getAttribute('data-label')||el.textContent;el.setAttribute('data-label',o);el.textContent=config('top', 'copy_success', 'LINK COPIED ✓');courtLater(function(){el.textContent=o;},2000);};
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(URL).then(done,function(){window.prompt(config('top', 'copy_prompt', 'Copy this link:'),URL);});}
    else{window.prompt(config('top', 'copy_prompt', 'Copy this link:'),URL);}
  }
  host.querySelectorAll('[data-share="copy"]').forEach(function(a){listen(a, 'click',function(e){e.preventDefault();copy(a);});});
  host.querySelectorAll('[data-share="native"]').forEach(function(b){listen(b, 'click',function(){
    if(navigator.share){navigator.share({title:config('top', 'share_title', 'VKE for pickleball'),text:TXT,url:URL}).catch(function(){});}
    else{var t=getId('openplay');if(t)t.scrollIntoView({behavior:'smooth'});}
  });});


  /* Concentration slider — ported verbatim (behaviour) from the home page #pick module. */
  (function(){
    var range=getId('concRange'), out=getId('concOut');
    if(!range||!out) return;
    var DATA=Array.prototype.map.call(host.querySelectorAll('.ladder .rung'), function(card){
  var pct=card.querySelector('.pct'), emoji=card.querySelector('.fEmoji');
  return {pct:pct ? pct.firstChild.textContent.trim()+'%' : '', name:(card.querySelector('.rname')||card).textContent.trim(), per:card.getAttribute('data-court-price')||'', emoji:emoji ? emoji.textContent : ''};
});
    var concentrationLabel=out.childNodes[1] ? out.childNodes[1].textContent : ' Veech Ketone Ester · ';
    var rungs=Array.prototype.slice.call(host.querySelectorAll('.ladder .rung'));
    var thumb=getId('concThumb');
    host.querySelectorAll('.rungImg').forEach(function(img){
      [img.dataset.sel,img.dataset.x].forEach(function(u){ if(u){ var pre=new Image(); pre.src=u; } });
    });
    function apply(){
      var i=parseInt(range.value,10), d=DATA[i]; if(!d) return;
      out.replaceChildren(); var bold=document.createElement('b'), price=document.createElement('span'); bold.textContent=d.pct; price.textContent=d.per; out.append(bold,document.createTextNode(concentrationLabel),price);
      if(thumb){ thumb.textContent=d.emoji; thumb.style.left='calc('+(i/(DATA.length-1))*100+'% + '+(24-(i/(DATA.length-1))*48)+'px)'; }
      rungs.forEach(function(r,k){
        var on=(k===i); r.classList.toggle('win',on);
        var img=r.querySelector('.rungImg');
        if(img){ var next=on?img.dataset.sel:img.dataset.x; if(next&&img.getAttribute('src')!==next) img.setAttribute('src',next); }
      });
    }
    listen(range, 'input',apply);
    rungs.forEach(function(r,k){ listen(r, 'mouseenter',function(){ if(parseInt(range.value,10)===k) return; range.value=k; apply(); }); });
    apply();
  })();

  /* Pickleball pong. Player = left paddle, The Banger = right. Rally scoring to 11, win by 2.
     Never autoplays; the loop only runs while a game is live and the court is on screen. */
  (function(){
    var root=getId('pkGame'); if(!root) return;
    var box=root.querySelector('.pkCourtBox'), cv=getId('pkCourt');
    var ctx=cv.getContext&&cv.getContext('2d'); if(!ctx) return;
    var ov=getId('pkOverlay'), mh=getId('pkMsgH'), ms=getId('pkMsgS');
    var play=getId('pkPlay'), shop=getId('pkShop');
    var eYou=getId('pkYou'), eCpu=getId('pkCpu'), eRally=getId('pkRallyN'), eBest=getId('pkBest');
    var reduce=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var W=0,H=0,state='idle',you=0,cpu=0,rally=0,best=0,inView=true,raf=0,last=0,wait=0,dir=1,err=0,key=0,target=null;
    var P={x:0,y:0,w:0,h:0}, C={x:0,y:0,w:0,h:0}, B={x:0,y:0,vx:0,vy:0,r:6,s:0}, trail=[];
    function clamp(v,a,b){ return v<a?a:(v>b?b:v); }
    function base(){ return Math.max(260,W*0.5); }
    function fit(){
      var r=box.getBoundingClientRect(); W=Math.max(200,r.width); H=Math.max(140,r.height);
      var dpr=Math.min(window.devicePixelRatio||1,2);
      cv.width=Math.round(W*dpr); cv.height=Math.round(H*dpr); ctx.setTransform(dpr,0,0,dpr,0,0);
      P.h=C.h=Math.max(46,H*0.24); P.w=C.w=Math.max(8,Math.min(12,W*0.01));
      P.x=Math.round(W*0.035); C.x=Math.round(W*0.965-C.w); B.r=Math.max(6,Math.min(9,H*0.03));
      if(state==='idle'){ P.y=C.y=H/2; B.x=W/2; B.y=H/2; }
      P.y=clamp(P.y,P.h/2,H-P.h/2); C.y=clamp(C.y,C.h/2,H-C.h/2);
      draw();
    }
    function hud(){ eYou.textContent=you; eCpu.textContent=cpu; eRally.textContent=rally; eBest.textContent=best; }
    function serve(d){
      B.x=W/2; B.y=H*(0.3+Math.random()*0.4); var a=Math.random()*0.7-0.35; B.s=base();
      B.vx=d*Math.cos(a)*B.s; B.vy=Math.sin(a)*B.s; trail=[]; aim();
    }
    function aim(){ err=(Math.random()-0.5)*C.h*(1.1+Math.min(rally,10)*0.03); }
    function start(){
      you=0; cpu=0; rally=0; hud(); state='wait'; wait=0.6; dir=Math.random()<0.5?-1:1;
      B.x=W/2; B.y=H/2; B.vx=B.vy=0; trail=[]; ov.hidden=true; shop.hidden=true; box.classList.add('is-on');
      try{ cv.focus({preventScroll:true}); }catch(e){}
      loop();
    }
    function point(winner){
      if(winner==='you') you++; else cpu++;
      best=Math.max(best,rally); rally=0; hud();
      if((you>=11||cpu>=11)&&Math.abs(you-cpu)>=2){ over(); return; }
      state='wait'; wait=0.7; dir=(winner==='you')?1:-1; B.x=W/2; B.y=H/2; B.vx=B.vy=0; trail=[];
    }
    function over(){
      state='over'; box.classList.remove('is-on'); var won=you>cpu;
      mh.textContent=won?(config('study', 'win_prefix', 'You win ')+you+'\u2013'+cpu+'.'):config('study', 'lost_heading', 'Don\u2019t be a sore loser.');
      ms.textContent=won?config('study', 'win_message', 'Up for another game?'):config('study', 'lost_message', 'Get KetoneAid for Recovery');
      play.textContent=won?config('study', 'play_again', 'PLAY AGAIN \u2192'):config('study', 'rematch', 'REMATCH \u2192'); shop.hidden=false; ov.hidden=false; draw();
    }
    function hit(p,d){
      var rel=clamp((B.y-p.y)/(p.h/2),-1,1), a=rel*1.0;
      B.s=Math.min(B.s*1.05,base()*2.1); B.vx=d*Math.cos(a)*B.s; B.vy=Math.sin(a)*B.s;
      B.x=(d>0)?(p.x+p.w+B.r):(p.x-B.r); rally++; eRally.textContent=rally; if(d>0) aim();
    }
    function step(dt){
      if(key){ P.y+=key*H*1.8*dt; } else if(target!==null){ P.y+=(target-P.y)*Math.min(1,dt*20); }
      P.y=clamp(P.y,P.h/2,H-P.h/2);
      var goal=(B.vx>0)?(B.y+err):H/2, mv=H*(0.95+Math.min(rally,12)*0.03)*dt, dy=goal-C.y;
      C.y+=(Math.abs(dy)<mv)?dy:(dy>0?mv:-mv); C.y=clamp(C.y,C.h/2,H-C.h/2);
      if(state==='wait'){ wait-=dt; if(wait<=0){ state='play'; serve(dir); } return; }
      if(state!=='play') return;
      B.x+=B.vx*dt; B.y+=B.vy*dt;
      if(B.y<B.r){ B.y=B.r; B.vy=Math.abs(B.vy); }
      if(B.y>H-B.r){ B.y=H-B.r; B.vy=-Math.abs(B.vy); }
      if(B.vx<0&&B.x-B.r<=P.x+P.w&&B.x+B.r>=P.x&&Math.abs(B.y-P.y)<=P.h/2+B.r) hit(P,1);
      if(B.vx>0&&B.x+B.r>=C.x&&B.x-B.r<=C.x+C.w&&Math.abs(B.y-C.y)<=C.h/2+B.r) hit(C,-1);
      if(B.x<-B.r*3) point('cpu'); else if(B.x>W+B.r*3) point('you');
      if(!reduce){ trail.push([B.x,B.y]); if(trail.length>6) trail.shift(); }
    }
    function rr(x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
    function paddle(p,c,left){
      ctx.fillStyle=c; rr(p.x,p.y-p.h/2,p.w,p.h,p.w/2); ctx.fill();
      rr(left?p.x-7:p.x+p.w-1,p.y-4,8,8,2); ctx.fill();
    }
    function ball(){
      ctx.fillStyle=config('study', 'court_color_1', '#E4F06A'); ctx.beginPath(); ctx.arc(B.x,B.y,B.r,0,6.2832); ctx.fill();
      ctx.fillStyle=config('study', 'court_color_2', 'rgba(70,80,20,.45)'); var q=B.r*0.42, h=Math.max(1.2,B.r*0.16);
      [[0,0],[q,0],[-q,0],[0,q],[0,-q]].forEach(function(o){ ctx.beginPath(); ctx.arc(B.x+o[0],B.y+o[1],h,0,6.2832); ctx.fill(); });
    }
    function draw(){
      ctx.clearRect(0,0,W,H);
      ctx.fillStyle=config('study', 'court_color_3', '#16221B'); rr(0,0,W,H,4); ctx.fill();
      var k1=W*0.341, k2=W*0.659;
      ctx.fillStyle=config('study', 'court_color_4', 'rgba(145,194,85,.08)'); ctx.fillRect(k1,9,k2-k1,H-18);
      ctx.lineWidth=1.5; ctx.strokeStyle=config('study', 'court_color_5', 'rgba(255,255,255,.28)'); ctx.strokeRect(8.5,8.5,W-17,H-17);
      ctx.strokeStyle=config('study', 'court_color_6', 'rgba(255,255,255,.16)'); ctx.beginPath(); ctx.moveTo(9,H/2); ctx.lineTo(k1,H/2); ctx.moveTo(k2,H/2); ctx.lineTo(W-9,H/2); ctx.stroke();
      ctx.strokeStyle=config('study', 'court_color_7', 'rgba(174,218,118,.6)'); ctx.beginPath(); ctx.moveTo(k1,9); ctx.lineTo(k1,H-9); ctx.moveTo(k2,9); ctx.lineTo(k2,H-9); ctx.stroke();
      ctx.setLineDash([6,6]); ctx.strokeStyle=config('study', 'court_color_8', 'rgba(255,255,255,.72)'); ctx.lineWidth=2;
      ctx.beginPath(); ctx.moveTo(W/2,4); ctx.lineTo(W/2,H-4); ctx.stroke(); ctx.setLineDash([]);
      if(W>560){ ctx.font='600 9px ui-monospace,SFMono-Regular,Menlo,monospace'; ctx.fillStyle=config('study', 'court_color_7', 'rgba(174,218,118,.6)'); ctx.textAlign='center';
        ctx.fillText(config('study', 'kitchen', 'KITCHEN'),(k1+W/2)/2,H-16); ctx.fillText(config('study', 'kitchen', 'KITCHEN'),(k2+W/2)/2,H-16); }
      paddle(P,config('study', 'court_color_9', '#91C255'),true); paddle(C,config('study', 'court_color_10', '#E6EAE6'),false);
      for(var i=0;i<trail.length;i++){ ctx.globalAlpha=(i+1)/(trail.length*4); ctx.fillStyle=config('study', 'court_color_1', '#E4F06A'); ctx.beginPath(); ctx.arc(trail[i][0],trail[i][1],B.r,0,6.2832); ctx.fill(); }
      ctx.globalAlpha=1; ball();
    }
    function frame(t){
      raf=0; if(!last) last=t; var dt=Math.min(0.033,(t-last)/1000); last=t;
      step(dt); draw();
      if((state==='play'||state==='wait')&&inView&&!document.hidden){ raf=courtFrame(frame); } else { last=0; }
    }
    function loop(){ if(!raf){ last=0; raf=courtFrame(frame); } }
    function setT(e){ var r=box.getBoundingClientRect(); target=clamp(e.clientY-r.top,0,H); key=0; }
    listen(box, 'pointermove',function(e){ if(state==='play'||state==='wait') setT(e); });
    listen(box, 'pointerdown',function(e){ if(state==='play'||state==='wait') setT(e); });
    listen(cv, 'keydown',function(e){
      var k=e.key;
      if(k==='ArrowUp'||k==='w'||k==='W'){ key=-1; target=null; e.preventDefault(); }
      else if(k==='ArrowDown'||k==='s'||k==='S'){ key=1; target=null; e.preventDefault(); }
      else if((k===' '||k==='Enter')&&(state==='idle'||state==='over')){ e.preventDefault(); start(); }
    });
    listen(cv, 'keyup',function(e){ var k=e.key; if(k==='ArrowUp'||k==='ArrowDown'||k==='w'||k==='W'||k==='s'||k==='S') key=0; });
    listen(play, 'click',start);
    listen(window, 'resize',fit);
    listen(document, 'visibilitychange',function(){ if(!document.hidden&&(state==='play'||state==='wait')) loop(); });
    if('IntersectionObserver' in window){
      observe(function(es){ inView=es[0].isIntersecting; if(inView&&(state==='play'||state==='wait')) loop(); }).observe(root);
    }
    fit(); hud();
  })();

  var ke2=getId('clubsKe2');
  if(ke2&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
    var on=false,raf=0;
    var upd=function(){raf=0;var r=ke2.getBoundingClientRect(),vh=window.innerHeight||1;
      var p=Math.min(Math.max(1-(r.top+r.height/2)/vh,0),1);ke2.style.transform='rotate('+(-28+p*34).toFixed(2)+'deg)';};
    var tick=function(){if(on&&!raf)raf=courtFrame(upd);};
    observe(function(es){on=es[0].isIntersecting;tick();}).observe(ke2);
    listen(window, 'scroll',tick,{passive:true});
  }
})();

  }
  function boot(){var root=document.getElementById('ka-goal');if(root)initialize(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',function(){var root=document.getElementById('ka-goal');if(root)initialize(root);});
  document.addEventListener('shopify:section:unload',function(){instances.forEach(function(cleanup){cleanup();});});
})();
